import { TRANSLATE_LANGUAGE } from "../constants/Define";
import BaseModel from "./BaseModel";

export default class PackageRateDescription extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.id = data.id || this.translate.id || undefined;
        this.packageRateId = data.packageRateId || this.translate.packageRateId || undefined;
        this.title = this.translate.title || undefined;
        this.extraInfos = this.translate.extraInfos || this.initExtraInfos();
        this.languageCode = this.languageCode === undefined ? TRANSLATE_LANGUAGE.VN.code : this.languageCode;
    }

    export() {
        const result = super.export({
            id: this.id,
            packageRateId: this.packageRateId,
            title: this.title,
            languageCode: this.languageCode,
            extraInfos: this.extraInfos
        });

        return result;
    }

    initExtraInfos() {
        return [
            { title: 'Mô tả', content: '' },
            { title: 'Bao gồm', content: '' },
            { title: 'Điều khoản', content: '' },
            { title: 'Chính sách hoàn hủy', content: '' }
        ]
    }
}